import {Form} from "react-router-dom";
import Input from "../../../../react/components/ui/spectre/Input";
import {DysonSphere, SpecificFactoryData} from "../../../types";
import React from "react";
import {Dropdown} from "../../../../react/components/ui/spectre/Dropdown";
import {ProliferatorType} from "../../../DSP/types";

type Props = {
    factoryGameData: SpecificFactoryData<DysonSphere>,
    setFactoryGameData: (newFactoryGameData: SpecificFactoryData) => void,
    translateDialogue: (key: string) => string,
}

export function FactoryGameDataDysonSphere({ factoryGameData, setFactoryGameData, translateDialogue }: Props) {
    function update(patch: Partial<SpecificFactoryData<DysonSphere>>) {
        setFactoryGameData({
            ...factoryGameData,
            ...patch,
        });
    }

    return <>
        <div>{translateDialogue('machineTier')}</div>
        <div>
            <Form onSubmit={e => e.preventDefault()}>
                <Input type='number' step={1} min={1} max={4}
                       onChange={(e) => !isNaN(e.target.valueAsNumber) && update({machineTier: e.target.valueAsNumber})}
                       value={(factoryGameData as SpecificFactoryData<DysonSphere>).machineTier}/>
            </Form>
        </div>

        <div>{translateDialogue('proliferatorType')}</div>
        <div>
            <Dropdown
                buttonTypes={[]}
                value={(factoryGameData as SpecificFactoryData<DysonSphere>).proliferatorType ?? ''}
                onChange={newValue => update({ proliferatorType: (newValue || null) as ProliferatorType })}
                options={{
                    '': translateDialogue('proliferatorTypeNone'),
                    [ProliferatorType.Product]: translateDialogue('proliferatorTypeProduct'),
                    [ProliferatorType.Speed]: translateDialogue('proliferatorTypeSpeed'),
                }}
            />
        </div>

        <div>{translateDialogue('proliferatorTier')}</div>
        <div>
            <Form onSubmit={e => e.preventDefault()}>
                <Input type='number' step={1} min={0} max={3}
                       onChange={(e) => !isNaN(e.target.valueAsNumber) && update({proliferatorTier: e.target.valueAsNumber})}
                       value={(factoryGameData as SpecificFactoryData<DysonSphere>).proliferatorTier}/>
            </Form>
        </div>
    </>
}
